import { render, staticRenderFns } from "./CompareCriterionsMultiple.vue?vue&type=template&id=6c806bb5&scoped=true"
import script from "./CompareCriterionsMultiple.vue?vue&type=script&lang=js"
export * from "./CompareCriterionsMultiple.vue?vue&type=script&lang=js"
import style0 from "./CompareCriterionsMultiple.vue?vue&type=style&index=0&id=6c806bb5&prod&lang=css"
import style1 from "./CompareCriterionsMultiple.vue?vue&type=style&index=1&id=6c806bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c806bb5",
  null
  
)

export default component.exports